export const APARTMENT = 'apartment';
export const STUDIO = 'studio';
export const ROOM_SHARED = 'room_shared';
export const RESIDENCE = 'residence';
export const LISTING_TYPES = [APARTMENT, STUDIO, ROOM_SHARED, RESIDENCE];

export const isApartment = type => type === APARTMENT;
export const isRoom = type => type === ROOM_SHARED;
